function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.429 0h3.428C15.43 0 16 .5 16 1v13c0 .5-.571 1-1.143 1H9.732a2 2 0 01-3.464 0H1.143C.57 15 0 14.5 0 14V1c0-.5.571-1 1.143-1H4.57C5.461 0 6.35.404 7 1.002V13a1 1 0 102 0V1.002C9.65.404 10.54 0 11.429 0z",
  fill: "#4F566B"
})));